<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Branch Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <!-- <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination" item-key="branch" :loading="loading" :no-data-text="noDataText" :custom-filter="customSearch" v-model="selected">
                <template v-slot:item="row">
                  <td style="width:50px">
                    <v-checkbox primary hide-details v-model="row.selected" @change="collectItems($event, row.item.branch)"></v-checkbox>
                  </td>
                  <td class="text-xs-left">{{ row.item.branch }}</td>
                  <td class="text-xs-left">{{ row.item.brnDesc }}</td>
                </template>
              </v-data-table> -->
              <v-data-table
              :headers="headers"
              :items="items"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :loading="loading"
              :server-items-length="totalItems"
              :custom-filter="customSearch"
              :no-data-text="noDataText"
              item-key="branch"
              v-model="selected"
              v-bind:options.sync="pagination"
              v-bind:search="search"
              >
              <template v-slot:item="row">
                <tr>
                  <td style="width:50px">
                    <v-checkbox primary hide-details v-model="row.selected" @change="collectItems($event, row.item.branch)"></v-checkbox>
                  </td>
                  <td class="text-xs-left">{{ row.item.branch }}</td>
                  <td class="text-xs-left">{{ row.item.brnDesc }}</td>
                </tr>
              </template>
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected. </div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mb-2" @click="doSelect('All', 'insured')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mb-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn>
              <v-btn color="primary" dark class="mb-2" @click="doSelect('', 'insured')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: '', value: 'branch' },
        { text: 'Branch', value: 'branch' },
        { text: 'Description', value: 'brnDesc' }
      ],
      pagination: {}
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    doInit() {
      const apiURI = this.menu.getBranchList
      if (apiURI) {
        this.loading = true
        this.$http.get(apiURI).then(result => {
          this.items = []
          this.selectedItems = []
          const { data } = result.data
          if (data) {
            data.map(brnList => {
              const convertList = {
                branch: brnList.branch,
                brnDesc: brnList.brnDesc
              }
              if (this.checkedItems.includes(brnList.branch)) {
                const branchList = {
                  branch: brnList.branch,
                  brnDesc: brnList.brnDesc
                }
                this.selectedItems.push(branchList)
              }
              this.items.push(convertList)
            })
          }
          if (this.checkedItems.toString() === 'All') {
            this.doReset()
            this.toggleAll()
          } else {
            this.toggleSelected()
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    helpListMixin
  ],
  props: {
    'menu': Object
  }
}
</script>

<style>
</style>
